<template>
  <el-submenu :index="parentItem.path">
    <template slot="title">
      <i class="icon" :class="parentItem.icon"></i>
      <span>{{ $t(parentItem.name) }}</span>
    </template>
    <template v-for="item in parentItem.children">
      <sidebar-item
        v-if="item.children && item.children.length !== 0"
        :parent-item="item"
        :key="'menu-'+item.path"
      ></sidebar-item>
      <el-menu-item v-else :index="item.path" :route="item.route" :key="'menu-'+ item.id">
        <i class="icon" :class="item.icon"></i>
        <span>{{ $t(item.name) }}</span>
      </el-menu-item>
    </template>
  </el-submenu>
</template>

<script>
export default {
	name: 'sidebar-item',
	props: {
		parentItem: {
			type: Object,
			default: () => {}
		}
	}
};
</script>
